import { useEffect } from 'react';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';

import TransactionLogs from 'components/transactions/TransactionLogs';
import { getTransaction, transactionHistory } from 'app/features/transactions/transactionSaga';

import { getTransactionReceipt } from 'app/features/transactions/transactionDocumentSaga';

import ViewTransactionDocument from './ViewTransactionDocument';

export default function ViewTransactionDetailDocument({
  onCustomerId,
  transaction,
  transactionLogs,
  isTransactionLoading,
}) {
  const dispatch = useDispatch();

  const { isLoading, data: transactionDocument } = useSelector(
    (state) => state.transactionDocument.show,
  );

  const customerId = transaction?.user_id;

  useEffect(() => {
    if (customerId && onCustomerId) onCustomerId(customerId);
  }, [customerId, onCustomerId]);

  useEffect(() => {
    const orderId = transaction?.order_id;
    if (orderId && String(orderId).trim()) {
      dispatch(
        getTransactionReceipt({
          orderId: String(orderId).trim(),
        }),
      );
    }
  }, [transaction, dispatch]);

  return (
    <Box>
      <ViewTransactionDocument transactionDocument={transactionDocument} isLoading={isLoading} />
      <Box sx={{ mt: 5 }}>
        <TransactionLogs data={transactionLogs} isLoading={isTransactionLoading} />
      </Box>
    </Box>
  );
}
